/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ProductPipelineRequirementGate {
    PipelineStart = 'PipelineStart',
    CustomerAdditionalDataSubmission = 'CustomerAdditionalDataSubmission',
    HvaRequestOfferts = 'HvaRequestOfferts',
    SvaRequestOfferts = 'SvaRequestOfferts',
    HvaCreateOffertVergleich = 'HvaCreateOffertVergleich',
    SvaCreateOffertVergleich = 'SvaCreateOffertVergleich',
    StartPolizzierung = 'StartPolizzierung',
    StartPolizzierungWithBeratungsprotokoll = 'StartPolizzierungWithBeratungsprotokoll',
    FinishContract = 'FinishContract'
  }

    export const ProductPipelineRequirementGateTranslocoMap: Record<ProductPipelineRequirementGate, string> = {
    [ProductPipelineRequirementGate.PipelineStart]: 'productPipelineRequirementGate.pipelineStart',
    [ProductPipelineRequirementGate.CustomerAdditionalDataSubmission]: 'productPipelineRequirementGate.customerAdditionalDataSubmission',
    [ProductPipelineRequirementGate.HvaRequestOfferts]: 'productPipelineRequirementGate.hvaRequestOfferts',
    [ProductPipelineRequirementGate.SvaRequestOfferts]: 'productPipelineRequirementGate.svaRequestOfferts',
    [ProductPipelineRequirementGate.HvaCreateOffertVergleich]: 'productPipelineRequirementGate.hvaCreateOffertVergleich',
    [ProductPipelineRequirementGate.SvaCreateOffertVergleich]: 'productPipelineRequirementGate.svaCreateOffertVergleich',
    [ProductPipelineRequirementGate.StartPolizzierung]: 'productPipelineRequirementGate.startPolizzierung',
    [ProductPipelineRequirementGate.StartPolizzierungWithBeratungsprotokoll]: 'productPipelineRequirementGate.startPolizzierungWithBeratungsprotokoll',
    [ProductPipelineRequirementGate.FinishContract]: 'productPipelineRequirementGate.finishContract',
    };

    export const ProductPipelineRequirementGateOptions = [
  { value: ProductPipelineRequirementGate.PipelineStart, labelKey: 'productPipelineRequirementGate.pipelineStart' },
  { value: ProductPipelineRequirementGate.CustomerAdditionalDataSubmission, labelKey: 'productPipelineRequirementGate.customerAdditionalDataSubmission' },
  { value: ProductPipelineRequirementGate.HvaRequestOfferts, labelKey: 'productPipelineRequirementGate.hvaRequestOfferts' },
  { value: ProductPipelineRequirementGate.SvaRequestOfferts, labelKey: 'productPipelineRequirementGate.svaRequestOfferts' },
  { value: ProductPipelineRequirementGate.HvaCreateOffertVergleich, labelKey: 'productPipelineRequirementGate.hvaCreateOffertVergleich' },
  { value: ProductPipelineRequirementGate.SvaCreateOffertVergleich, labelKey: 'productPipelineRequirementGate.svaCreateOffertVergleich' },
  { value: ProductPipelineRequirementGate.StartPolizzierung, labelKey: 'productPipelineRequirementGate.startPolizzierung' },
  { value: ProductPipelineRequirementGate.StartPolizzierungWithBeratungsprotokoll, labelKey: 'productPipelineRequirementGate.startPolizzierungWithBeratungsprotokoll' },
  { value: ProductPipelineRequirementGate.FinishContract, labelKey: 'productPipelineRequirementGate.finishContract' },
    ];

